export var defaultAriaLiveMessages = {
  onChange: function onChange(props) {
    var action = props.action,
      _props$label = props.label,
      label = _props$label === void 0 ? '' : _props$label,
      isDisabled = props.isDisabled;
    switch (action) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return label.length ? "option ".concat(label, ", deselected") : '';
      case 'clear':
        return 'All selected options have been cleared.';
      case 'select-option':
        return label.length && !isDisabled ? "option ".concat(label, ", selected.") : '';
      default:
        return '';
    }
  },
  onFilter: function onFilter(props) {
    var inputValue = props.inputValue,
      resultsMessage = props.resultsMessage;
    return inputValue ? "".concat(resultsMessage, " for search term ").concat(inputValue, ".") : '';
  }
};